
import paywithpoint from "./config/paywithpointConfig";

export default {
    config: function (mainApp) {
        var config = null;
        switch (mainApp) {
            case 'paywithpoint':
                config = paywithpoint.config();
                break;
        }
        return config;
    },
}
